import { Button, ButtonProps, styled, Typography } from "@mui/material";
import { bgMainColor, borderRadiusLarge } from "../theme";

export const StyledButton = styled(Button)<
  ButtonProps & React.AnchorHTMLAttributes<HTMLAnchorElement>
>(({ theme }) => ({
  margin: theme.spacing(1, 0),
}));

export const StyledButtonInverted = styled(Button)(({ theme }) => ({
  margin: theme.spacing(1, 0),
  backgroundColor: "black",
  color: bgMainColor,
  "&:hover": {
    backgroundColor: bgMainColor,
    color: "black",
  },
  "&.Mui-disabled": {
    backgroundColor: theme.palette.action.disabledBackground,
    color: theme.palette.action.disabled,
  },
}));

export const StyledButtonValue = styled(Button)(({ theme }) => ({
  margin: theme.spacing(1, 0),
  padding: theme.spacing(2),
  [theme.breakpoints.up("md")]: {
    margin: theme.spacing(2, 0),
  },
  ...theme.typography.h5,
  border: "1px solid",
  borderRadius: borderRadiusLarge,
  "@media (hover: none)": {
    "&:hover": {
      backgroundColor: theme.palette.primary.main,
      borderColor: theme.palette.secondary.main,
      border: "1px solid",
      color: theme.palette.secondary.main,
    },
    "&:active": {
      backgroundColor: theme.palette.secondary.main,
      borderColor: theme.palette.primary.main,
      border: "1px solid",
      color: theme.palette.primary.main,
      // Reset active styles
    },
  },
}));

export const StyledTypographyValue = styled(Typography)`
  ${(props) => props.theme.typography.h4};
  ${(props) => props.theme.breakpoints.up("md")} {
    ${(props) => props.theme.typography.h2};
  }
`;
